import { Button, Tooltip } from 'antd';
import './MapZoomButtons.less';
import { useAppSelector } from '../../../store/hooks/hooks';
import { selectMapTutorial } from '../../../store/slice/mapSlice';
import { useState } from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as Plus } from '../../../res/svg/map_plus.svg';
import { ReactComponent as Minus } from '../../../res/svg/minus.svg';

interface Props {
  onZoomOut?: () => any;
  onZoomIn?: () => any;
}

function MapZoomButtons({ onZoomIn, onZoomOut }: Props) {
  const mapTutorial = useAppSelector(selectMapTutorial);
  const [hover, setHover] = useState<boolean>(false);

  return (
    <Tooltip title={<div><p>Acercar mapa.</p><p style={{marginBottom: 0}}>Alejar mapa.</p></div>}
             visible={mapTutorial ? true : hover}
             trigger={'hover'}
             placement={'left'}
    >
      <div className='at-map-zoom-buttons__container'>
        <Button
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          size='large'
          shape='round'
          className={'at-map-zoom-buttons__button'}
          onClick={onZoomIn as any}
          type={'ghost'}
          icon={<Icon component={Plus} />}
        >
        </Button>

        <Button
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          className={'at-map-zoom-buttons__button'}
          size='large'
          shape='round'
          onClick={onZoomOut as any}
          type={'ghost'}
          icon={<Icon component={Minus} />}
        >

        </Button>
      </div>

    </Tooltip>
  );
}

export default MapZoomButtons;
